import React from 'react';
import styled, { css } from 'styled-components';
import propTypes from 'prop-types';
import { FormatTypes } from '../../../../../cra/src/constants/templateDictionaries';
import { PrimaryDark } from '../../../../../cra/src/styling/theme';
import breakpoints from '../../../../../cra/src/styling/breakpoints';
import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

const RightToolbarWrapper = styled.ul`
  grid-column: 9/-1;
  transform: translateX(16px);
  list-style: none;
  font-size: 14px;
  height: inherit;
  align-self: flex-start;
  justify-self: right;
  margin: 0;
  padding-right: 24px;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0;

  @media screen and (min-width: 1366px) {
    font-size: 16px;
  }

  ${(props) => {
    const { pathname, user, formatType } = props;
    if (pathname === '/') {
      return css`
        padding-right: 16px;
        grid-column: 4 / 9;

        @media ${breakpointsMinWidth.tabletMd} {
          grid-column: 7 / -2;
          padding-right: 0;
        }
        @media ${breakpointsMinWidth.desktopSm} {
          grid-column: 8 / -2;
          padding-right: 0;
        }
        @media ${breakpointsMinWidth.desktopMd} {
          grid-column: 8 / span 4;
          padding-right: 0;
        }
      `;
    }
    if (
      pathname.startsWith('/drive') ||
      pathname.startsWith('/account') ||
      pathname.startsWith('/support') ||
      pathname.startsWith('/billings') ||
      pathname.startsWith('/services') ||
      pathname.startsWith('/learn') ||
      (pathname.startsWith('/documents/') &&
        formatType === FormatTypes.CAREER_FINANCIALS)
    ) {
      return css`
        padding-right: 50px;
        grid-column: 6 / -1;
        grid-row: 1;
        @media screen and (max-width: 2560px) {
          grid-column: 6 / -1;
          padding-right: 40px;
        }
        margin: 0;
        @media screen and (max-width: 1280px) {
          grid-column: 6 / -1;
        }
        @media screen and (max-width: 1023px) {
          height: 60px;
        }
      `;
    }

    if (!pathname.includes('/documents/')) {
      return css`
        grid-column: ${() => (user ? '8 /span 4' : '6 / -2')};

        li.profileIcon {
          position: relative;
          .drop-down,
          .profile {
            left: auto;
            right: 0;
            line-height: 28px;
            padding: 0.5rem;
            width: 200px;

            background-color: #fff;
            border-radius: 0.4rem;
            box-shadow: 0 4px 10px 1px rgba(41, 49, 89, 0.2);
            z-index: 3;

            li {
              font-size: 14px;
              line-height: 28px;
              @media screen and (min-width: 1366px) {
                font-size: 16px;
                line-height: 28px;
              }
              color: #333d47;
              text-align: left;

              &:hover {
                background: none;
                color: ${PrimaryDark};
                font-weight: 400;
              }
            }

            @media ${breakpointsMinWidth.desktopLg} {
              width: 232px;
            }
          }
        }

        @media ${breakpointsMinWidth.desktopLg} {
          grid-column: 8 / span 4;
        }
        @media ${breakpoints.desktopLg} {
          grid-column: ${() => (user ? '8 /-2' : '6 / -2')};
        }

        @media ${breakpoints.desktopMd} {
          grid-column: ${() => (user ? '7 /-2' : '7 / -2')};
          margin-right: 0;
          padding-right: 0;
        }

        @media screen and (max-width:1023px) {
          grid-column: 4 / 9;
          padding-right: 36px;
        }

        @media screen and (max-width:767px) {
          display: grid;
          grid-template-rows: repeat(auto-fill, 72px);
          height: 100vh;
          width: 240px;
          background: white;
          margin-right: 0;
          padding:0

          li: {
            text-align: left;
          }
        }
      `;
    }

    return css`
      margin-right: 26px;
    `;
  }}

  @media screen and (max-width: 767px) {
    display: ${(props) => !props.pathname.includes('/documents/') && 'none'};
  }
`;

const RightToolbar = (props) => {
  const { children, pathname, user } = props;
  return (
    <RightToolbarWrapper pathname={pathname} user={user}>
      {children}
    </RightToolbarWrapper>
  );
};

RightToolbar.propTypes = {
  children: propTypes.node.isRequired,
  pathname: propTypes.string.isRequired,
  user: propTypes.objectOf(propTypes.object),
};

RightToolbar.defaultProps = {
  user: null,
};

export default RightToolbar;
